import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from '../../../../util/axios-instance';

export const updateCustomerProfile = async (
  projectId: string,
  profileId: string,
  body: {
    [key: string]: any;
  }
) => {
  const response = await api.put(
    `${API_URL}/v1/project/${projectId}/ecommerce/profile/${profileId}`,
    body,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};
